var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: { title: _vm.title, visible: _vm.formVisible, width: "70%" },
      on: {
        "update:visible": function ($event) {
          _vm.formVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "setup-details-form" },
        [
          _c("h3", [_vm._v("Details")]),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 40 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("section", [
                  _c("strong", [_vm._v("Created At")]),
                  _vm._v(" "),
                  _c(
                    "span",
                    [
                      _c("time-zone-formatter", {
                        attrs: { "current-time": _vm.details.created_at },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Device Name")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.doorbot_description))]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Ring Device Connected")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.doorbot_connected))]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("section", [
                  _c("strong", [_vm._v("Status")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.status))]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Device Id")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.doorbot_device_id))]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Client Device Connected")]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(_vm._s(_vm.details.client_device_connected)),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("section", [
                  _c("strong", [_vm._v("Client Device Id")]),
                  _vm._v(" "),
                  _c("span", [_vm._v("N/A")]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Is First")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.is_first))]),
                ]),
                _vm._v(" "),
                _c("section", [
                  _c("strong", [_vm._v("Changed Owner")]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.details.changed_owner))]),
                ]),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c("h3", [_vm._v("Metadata")]),
          _vm._v(" "),
          _vm._l(_vm.metadata, function (data) {
            return _c(
              "el-row",
              { key: data.id, staticClass: "setup-details__metadata" },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("strong", [_vm._v(_vm._s(data.label))]),
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(data.value))]),
                ]),
                _vm._v(" "),
                _c("el-col", { attrs: { span: 12 } }),
              ],
              1
            )
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }